// AI-CONTEXT: See docs/features/update-aanvragen.md

import formatUpdateDate from '../updates/formatUpdateDate'

/**
 * Zet het tijdstempel van een updateverzoek om naar '25 augustus 2026'.
 *
 * De datumdelen komen uit de lokale tijd, niet uit toISOString(): die rekent
 * naar UTC, waardoor een verzoek van 's avonds laat een dag terugschuift. Geen
 * Intl, omdat de repo-lokale node small-icu draait en locale-uitvoer daar per
 * omgeving verschilt.
 *
 * De opmaak zelf komt uit formatUpdateDate, zodat een verzoek en een geleverde
 * update dezelfde schrijfwijze hebben.
 *
 * @param {*} timestamp - Firestore-Timestamp uit een UpdateRequests-document
 * @returns {string} '25 augustus 2026', of '' als er geen bruikbare datum is
 */
const formatRequestDate = (timestamp) => {
    if (typeof timestamp?.toDate !== 'function') return ''

    const date = timestamp.toDate()
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) return ''

    const maand = String(date.getMonth() + 1).padStart(2, '0')
    const dag = String(date.getDate()).padStart(2, '0')

    return formatUpdateDate(`${date.getFullYear()}-${maand}-${dag}`)
}

export default formatRequestDate
